import { useTranslation } from "react-i18next";

import { useUpdatePolicyMutation } from "@dashboard/policies/api";
import type { UpdatePolicyPayload } from "@dashboard/policies/api/rtkClient";
import { showSuccessToast } from "@shared/toasts/Toasts";

export const usePolicyContentUpdate = () => {
    const { t } = useTranslation(["pages"]);
    const [updatePolicy, { isLoading }] = useUpdatePolicyMutation();

    const updateContent = async (payload: UpdatePolicyPayload): Promise<boolean> => {
        try {
            await updatePolicy(payload).unwrap();
            showSuccessToast(t("pages:policiesPage.toast.rulesUpdated"));
            return true;
        } catch {
            // The policies API's transformErrorResponse already shows an error toast for the failed
            // request, so there is nothing left to do here besides reporting failure to the caller.
            return false;
        }
    };

    return { updateContent, isLoading };
};
